import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { RequiredDirective } from '../../misc/directives/required.directive';
import { MiscModule } from '../../misc/misc.module';
import { OwnerPageRoutingModule } from './owner-routing.module';
import { OwnerPageComponent } from './owner.page';

@NgModule({
  declarations: [OwnerPageComponent],
  imports: [
    CommonModule,
    IonicModule,
    OwnerPageRoutingModule,
    ReactiveFormsModule,
    MiscModule,
    MaskitoDirective,
    ErrorMessageDirective,
    RequiredDirective
  ]
})
export class OwnerPageModule {}
